// Singleton WebSocket for instant (<1s) data sync across the app.
const listeners = new Set();
let socket = null;
let retryMs = 1000;
let pingId = null;

const getToken = () =>
  localStorage.getItem('token') || sessionStorage.getItem('token');

function scheduleReconnect() {
  if (listeners.size === 0) return;
  setTimeout(connect, retryMs);
  retryMs = Math.min(retryMs * 2, 15000);
}

function connect() {
  if (socket && (socket.readyState === WebSocket.CONNECTING || socket.readyState === WebSocket.OPEN)) return;
  const base = process.env.REACT_APP_BACKEND_URL;
  const token = getToken();
  if (!base || !token || listeners.size === 0) return;
  try {
    socket = new WebSocket(`${base.replace(/^http/, 'ws')}/api/ws?token=${encodeURIComponent(token)}`);
  } catch {
    socket = null;
    scheduleReconnect();
    return;
  }
  socket.onopen = () => {
    retryMs = 1000;
    clearInterval(pingId);
    pingId = setInterval(() => {
      try {
        if (socket && socket.readyState === WebSocket.OPEN) socket.send('ping');
      } catch {}
    }, 25000);
  };
  socket.onmessage = (e) => {
    let msg;
    try { msg = JSON.parse(e.data); } catch { return; }
    listeners.forEach((fn) => { try { fn(msg); } catch {} });
  };
  socket.onclose = (e) => {
    clearInterval(pingId);
    socket = null;
    // 4401 = auth rejected — don't hammer; visibilitychange/online will
    // retry with whatever token is current at that point.
    if (e && e.code === 4401) return;
    scheduleReconnect();
  };
  socket.onerror = () => {
    try { socket && socket.close(); } catch {}
  };
}

if (typeof window !== 'undefined') {
  window.addEventListener('online', connect);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') connect();
  });
}

// Subscribe to realtime messages. Returns an unsubscribe function.
export function subscribeRealtime(fn) {
  listeners.add(fn);
  connect();
  return () => { listeners.delete(fn); };
}
